import type { components } from "../../apis/gen";

export type ResultDetail = components["schemas"]["ResultDetail"];
export type StoreEvent = components["schemas"]["Event"];
export type StoreSession = components["schemas"]["Session"];
export type AgentStatus = components["schemas"]["AgentStatus"];

export interface ResultDetailExtended extends ResultDetail {
	result_idx: any;
	field_goal_result: string;
}

export enum EventActionTypes {
	SET_EVENT = "Events/SET_EVENT",
	UPDATE_EVENT = "Events/UPDATE_EVENT",
	CLEAR_EVENT = "Events/CLEAR_EVENT",
	FETCH_EVENT = "Events/FETCH_EVENT",
	ADD_SESSION_RESULT = "Events/ADD_SESSION_RESULT",
	APPEND_SESSION = "Events/APPEND_SESSION",
	CONNECT_SSE = "Events/CONNECT_SSE",
	CLOSE_SSE = "Events/CLOSE_SSE",
	ADD_SESSION_HIGHLIGHT = "Events/ADD_SESSION_HIGHLIGHT",
	UPDATE_SESSION_HIGHLIGHT = "Events/UPDATE_SESSION_HIGHLIGHT",
	EVENT_BOOKED = "Events/EVENT_BOOKED",
	EVENT_CHECKED_IN = "Events/EVENT_CHECKED_IN",
	SESSION_STREAM_READY = "Events/SESSION_STREAM_READY",
	SESSION_SHARELINK_READY = "Events/SESSION_SHARELINK_READY",
	SESSION_PROCESSING_DONE = "Events/SESSION_PROCESSING_DONE",
	SESSION_ARCHIVED = "Events/SESSION_ARCHIVED",
}

export type setEventPayload = {
	eventId: string;
	eventData: StoreEvent;
};

export type updateEventPayload = {
	eventId: string;
	updateData: Partial<StoreEvent>;
};

export type addSessionResultPayload = {
	eventId: string;
	sessionIdx: number;
	resultIdx: number;
	result: ResultDetail;
};

export type State = {
	events: Record<string, StoreEvent>;
	sse_connected: boolean;
	agents: AgentStatus[];
	agentsLoading: boolean;
	agentsError: string | null;
	appendTokens: Record<string, string>;
	checkInTokens: Record<string, string>;
};
